module.exports = __webpack_public_path__ + "img/Ticto-2-en.6d07b24a.png";